var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7,0a7,7,0,1,0,7,7A7,7,0,0,0,7,0ZM7,3.5a.875.875,0,1,1-.875.875A.875.875,0,0,1,7,3.5Zm1.313,7H5.688a.438.438,0,0,1,0-.875h.438V7H5.688a.438.438,0,0,1,0-.875h1.75a.438.438,0,0,1,.438.438V9.625h.438a.437.437,0,0,1,0,.875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.6ab09db4.svg";
export { ForwardRef as ReactComponent };